import { translations } from "./lang";

export const handleTextAreaResize = (e) => {
  e.target.style.height = "auto";
  e.target.style.height = `${e.target.scrollHeight}px`;
};

export const getLightThemeColor = (strategicTheme) => {
  return strategicTheme?.match("Patient Access")
    ? "rgb(255, 185, 240)"
    : strategicTheme?.match("Patient Experience")
    ? "rgb(208, 255, 222)"
    : strategicTheme?.match("Patient Safety")
    ? "rgb(180, 217, 252)"
    : strategicTheme?.match("People")
    ? "rgb(255, 194, 194)"
    : strategicTheme?.match("Sustainability")
    ? "rgb(250, 225, 170)"
    : strategicTheme?.match("Systems & Partnership")
    ? "rgb(212, 162, 212)"
    : "#f5f7f5";
};

export const getThemeColor = (strategic_theme) => {
  return strategic_theme.match("Patient Access")
    ? "rgb(223, 0, 174)"
    : strategic_theme?.match("Patient Experience")
    ? "rgb(102, 211, 135)"
    : strategic_theme?.match("Patient Safety")
    ? "#1156f7"
    : strategic_theme?.match("People")
    ? "#eb020a"
    : strategic_theme?.match("Sustainability")
    ? "#fc620f"
    : strategic_theme?.match("Systems & Partnership")
    ? "#7c04d1"
    : "#09d966";
};

export const getTranslation = (label, language) => {
  return translations[label]
    ? translations[label][language]
      ? translations[label][language]
      : label
    : label;
};

export const categories = [
  {
    value: "L1",
    label: "L1 Executive Access",
    desc: "For CEOs, COOs, Strategy Directors",
  },
  {
    value: "L2",
    label: "L2 Director Access",
    desc: "For Divisional Heads, Theme Leaders",
  },
  {
    value: "L3",
    label: "L3 Manager Access",
    desc: "For Department Heads, Team Leaders",
  },
  { value: "L4", label: "L4 Standard Access", desc: "For All Team Members" },
];
